import { Box } from "@mui/system";
import React, { useEffect, useState } from "react";
import { Chart, Interval, Axis, Tooltip, Coordinate } from "bizcharts";
import DataSet from "@antv/data-set";
import { CircularProgress } from "@mui/material";

const getChunks = (array, chunk_size) =>
  Array(Math.ceil(array.length / chunk_size))
    .fill()
    .map((_, index) => index * chunk_size)
    .map((begin) => array.slice(begin, begin + chunk_size));

const Samples = (props) => {
  let data;
  let chunks;
  let scale;
  let sum;

  const height = props.chunkSize === 3 ? 160 : 170;
  if (props.data) {
    data = props.data.data;
    chunks = getChunks(data, Math.ceil(props.chunkSize / 4));
    scale = {
      Samples: {
        min: 0,
        max: Math.max(...props.data.data.map((d) => d["Samples"])),
      },
    };
    sum = data
      .map((c) => c["Samples"])
      .reduce((partialSum, a) => partialSum + a, 0);
  }

  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    setIsLoading(true);
    setTimeout(() => {
      setIsLoading(false);
    }, 700);
  }, []);

  return (
    <Box padding={props.padding}>
      <Box sx={{display: "block"}}>
        <p
          style={{
            fontFamily: "Roboto Condensed, sans-serif",
            marginBottom: "0.375rem",
          }}
        >
          <b>
            Number of samples taken per country of origin from {" "}
            {/* <u> */}
              {props.data !== undefined
                ? props.data.country === "All"
                  ? "the reporting countries"
                  : props.data.country
                : ""}
            {/* </u> */}
          </b>
          <b> (Total : {props.data !== undefined ? sum.toLocaleString() : ""})</b>
        </p>
      </Box>

      {isLoading ? (
        <Box sx={{ display: "flex", justifyContent: "center" }}>
          <CircularProgress />
        </Box>
      ) : (
        <Box  sx={{
          display: "flex",
          flexDirection: "column",
          flexWrap: "wrap",
          maxHeight: "275px",
          gap: "10px"
        }}>
          {props.data && data && data.sort((a,b) => a['Samples'] > b['Samples'] ? -1 : 1 ).map((c, idx) => {
              return (
                  <Box
                    key={idx}
                    sx={{
                      flex: "0 1 50%",
                      boxSizing: "border-box",
                      p: 0.5,
                      fontFamily: "Roboto Condensed, sans-serif",
                      display: "flex",
                      fontSize: "14px",
                      borderBottom: "1px solid grey",
                      justifyContent: "space-between"
                    }}
                  >
                    <Box>{c['Country of origin']}</Box> <Box sx={{ fontWeight: "bold" }}>{c['Samples'].toLocaleString()}</Box>
                </Box>
              );
            })}
        </Box>
      )}
    </Box>
  );
};

export default Samples;
